import * as L from 'leaflet';
import S from 's-js';
import { parseZoneCoordinates, LatLong, LocationCoords, PolygonCoords, CircleCoords } from 'data/models/ZoneCoordinates';
import { Location } from 'data/models/Location';

export const MAP_FILL_COLOR = '#E8E343';

export function drawPolygonLocation(coords : PolygonCoords) {
    return coords.toLeaflet({ color: MAP_FILL_COLOR, weight: 2, fillColor: MAP_FILL_COLOR, fillOpacity: .1 });
}

export function drawCircleLocation(coords : CircleCoords) {
    return coords.toLeaflet({ color: MAP_FILL_COLOR, weight: 2, fillColor: MAP_FILL_COLOR, fillOpacity: .1 });
}

// TH 12/19/2016 -- Common interface satisfied by both L.Map and L.LayerGroup<ILayer>
interface LeafletLayerContainer {
    addLayer(layer : L.Layer) : void;
    removeLayer(layer : L.Layer) : void;
}

export function drawLocation(container : LeafletLayerContainer, coords : LocationCoords) : L.LatLng | null {
    let center : L.LatLng | null = null;

    if (!coords) {
        // ignore locations without coordinates
    } else if (coords instanceof PolygonCoords) {
        const polygon = drawPolygonLocation(coords);
        container.addLayer(polygon);
        S.cleanup(() => container.removeLayer(polygon));
        center = polygon.getBounds().getCenter();
    } else {
        const circle = drawCircleLocation(coords);
        container.addLayer(circle);
        S.cleanup(() => container.removeLayer(circle));
        center = circle.getLatLng();
    }

    return center;
}


// WEBPACK FOOTER //
// ./apps/portcall/maps/maptools.ts